export const BurgerMenuIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M31 6C31.5523 6 32 6.44772 32 7C32 7.55228 31.5523 8 31 8H1C0.447715 8 0 7.55228 0 7C0 6.44772 0.447715 6 1 6H31Z"
                fill="currentColor"
            />
            <path
                d="M31 16C31.5523 16 32 16.4477 32 17C32 17.5523 31.5523 18 31 18H1C0.447715 18 0 17.5523 0 17C0 16.4477 0.447715 16 1 16H31Z"
                fill="currentColor"
            />
            <path
                d="M31 26C31.5523 26 32 26.4477 32 27C32 27.5523 31.5523 28 31 28H1C0.447715 28 0 27.5523 0 27C0 26.4477 0.447715 26 1 26H31Z"
                fill="currentColor"
            />
        </svg>
    );
};
